import React from 'react';
import { faCalendarTimes } from '@fortawesome/free-solid-svg-icons';
import { FormGroup } from 'reactstrap';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormCheckbox
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { handleFormSaveError } from '../common/forms/ValidationError';
import Input from 'components/common/forms/Input';

class CertificationViewModel {
    id = 0;
    name = '';
    abbreviation = '';
    willExpire = false;
    proofRequired = false;
    attachment = null;
    isActive = true;
    tenantId = 0;
}

export default class CertificationForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        this.state = {
            selectedCertification:
                props.selectedCertification ?? new CertificationViewModel(),
            ...new BaseFormViewModel(),
            loading: false
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onClose = (response) => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    };
    onSubmit = async (e) => {
        this.clearErrors();
        this.props.onSaveCallback();
        this.resetForm();
    };

    clearErrors = () => this.setState({ errors: {} });
    handleSaveError = (err) => handleFormSaveError(this, err);
    resetForm = () => this.setState({ formValidated: false });

    render() {
        const { formValidated, validationMessage, loading } = this.state;
        const { selectedCertification, show, onChange } = this.props;

        if (!selectedCertification) {
            return null;
        }

        return (
            <SlideForm
                loading={loading}
                show={show}
                id="certificationForm"
                formIcon={faCalendarTimes}
                formTitle={
                    selectedCertification.id
                        ? 'Edit Certification'
                        : 'Add Certification'
                }
                ref={this.formRef}
                setIsValidated={(value) => this.setState({ formValidated: value })}
                isValidated={formValidated}
                removeUnavailable={true}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                onClearErrors={this.clearErrors}
                validationMessage={validationMessage}
                entityId={selectedCertification.id}
            >

                <Input
                    label="Name"
                    id="name"
                    name="selectedCertification.name"
                    value={selectedCertification.name || ''}
                    onChange={onChange}
                    placeholder="Enter Name"
                    maxLength={250}
                    error="Name is required."
                    required
                />
                <Input
                    label="Abbreviation"
                    id="abbreviation"
                    name="selectedCertification.abbreviation"
                    value={selectedCertification.abbreviation || ''}
                    onChange={onChange}
                    placeholder="Enter the Abbreviation for Certification"
                    maxLength={6}
                    error="Abbreviation is required"
                    required
                />

                <FormGroup>
                    <FormCheckbox
                        id="proofRequired"
                        name="selectedCertification.proofRequired"
                        checked={!!selectedCertification.proofRequired}
                        onChange={onChange}
                        labelText="Requires Proof"
                    />
                </FormGroup>

                <FormGroup>
                    <FormCheckbox
                        id="willExpire"
                        name="selectedCertification.willExpire"
                        checked={!!selectedCertification.willExpire}
                        onChange={onChange}
                        labelText="Expires"
                    />
                </FormGroup>

                <FormGroup>
                    <FormCheckbox
                        id="isActive"
                        name="selectedCertification.isActive"
                        checked={!!selectedCertification.isActive}
                        onChange={onChange}
                        labelText="Active"
                    />
                </FormGroup>

            </SlideForm>
        );
    }
}
